<template>
  <ConsolidationMeestEditingSection
          :CM="CM"
          @save="save"
  />
</template>

<script>
  import {ConsolidationMeest} from "../../models/ConsolidationMeest";
  import ConsolidationMeestEditingSection from "./ConsolidationMeestEditingSection/ConsolidationMeestEditingSection";
  import {consolidationMeestMixin} from "@/mixins/consolidationMeestMixins/consolidationMeestMixin";

  export default {
    name: "ConsolidationMeestCreation",

    components:{
      ConsolidationMeestEditingSection,
    },

    mixins: [consolidationMeestMixin],

    data() {
      return {
        CM: new ConsolidationMeest(),
        transactionUser: {},
      }
    },

    mounted() {
      this.initConsolidationMeestEdit()
    },

    methods: {

      initConsolidationMeestEdit() {
        this.CM.data.Order.setId(this.$route.params.id)

        this.$store.dispatch('getConsolidationMeest', this.CM.data.Order.getId()).then((response) => {
          let item = this.getRespData(response)
          this.CM.setItem(item, this)
        }).catch(error => this.createErrorLog(error))
      },

    }

  }
</script>

<style scoped>

</style>
